import { createClient } from '@connectrpc/connect';
import { PcfMappingService } from './gen/pcf_mapping_service_pb';
import { getGrpcTransport } from './transport';

export function getPcfMappingGrpcClient() {
  const transport = getGrpcTransport();
  return transport ? createClient(PcfMappingService, transport) : null;
}
